import { Component, OnInit } from '@angular/core';
import { BaseComponent } from 'app/base/base.component';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Merchant } from 'app/core/models/merchant';
import { PointOfService } from 'app/core/models/pointOfService';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticatedRouteGuard } from 'security/authenticatedRouteGuard.service';
import { NotifMessageService } from 'app/core/services/notifmessage.service';
import { MerchantService } from 'app/core/services/merchant.service';
import { PosService } from 'app/core/services/pos.service';
import { AcceptanceAccountsService } from 'app/core/services/acceptanceAccounts.service';
import { AcceptanceAccount } from 'app/core/models/acceptanceaccount';
import { Subscription, Observable } from 'rxjs';
import { Items } from 'app/core/models/items';
import { map, take } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { SupplierService } from 'app/core/services/supplier.service';
import { AbstractMerchantSupplierComponent } from 'app/core/common/abstract.merchant-supplier.component';
import { jsonValidator } from 'app/core/common/jsonValidator';
import { TranslateService } from '@ngx-translate/core';
import {IssuerType} from "../../core/models/issuerType";

@Component({
  selector: 'app-acceptance-account-crud',
  templateUrl: './acceptance-account-crud.component.html'
})
export class AcceptanceAccountCrudComponent extends AbstractMerchantSupplierComponent implements OnInit {

  isLoading: boolean = false;

  isCreateMode: boolean;
  isEditMode: boolean;
  isDetailsMode: boolean;

  acceptanceAccount: AcceptanceAccount;
  acceptanceAccountId: number;
  acceptanceAccountForm: FormGroup;

  acceptanceAccountProviderItems: Array<string> = Array<string>();

  allMerchants = new Array<Merchant>();
  allPOS = new Array<PointOfService>();
  allIssuerTypes: IssuerType[] = [
    new IssuerType('FUEL_CARD'),
    new IssuerType('PRIVATE_PAYMENT'),
    new IssuerType('SEPA'),
    new IssuerType('UNIVERSAL_PAYMENT'),
    new IssuerType('PIS')
  ];
  posEnroll : PointOfService = new PointOfService();
  posId: string;
  supplierId: number;
  supplierName: string;
  pos: PointOfService;
  criteria = {}

  posTotalPages = 0;
  posPager = {
    page: 0,
    sort: "createdDate,DESC",
    size: 10
  };

  constructor(
    protected formBuilder: FormBuilder,
    protected log: NGXLogger,
    public router: Router,
    public route: ActivatedRoute,
    protected roleGuard: AuthenticatedRouteGuard,
    protected notifService: NotifMessageService,
    protected merchantService: MerchantService,
    protected posService: PosService,
    protected supplierService: SupplierService,
    private translateService: TranslateService,
    protected acceptanceAccountService: AcceptanceAccountsService) {
      super(supplierService, merchantService, posService, log, router);
  }

  ngOnInit(): void {
    this.acceptanceAccountProviderItems = this.getAccacProvider();
    this.acceptanceAccountId = this.route.snapshot.params['id'];
    this.isCreateMode = !this.acceptanceAccountId;

    if (this.roleGuard.isEnabled('MERCHANT_READ')) {
      this.getMerchants();
    }
    if(this.roleGuard.isEnabled('POS_READ')){
      this.getPos();
    }

    if (this.isCreateMode) {
      this.initForm();
    } else {
    this.isLoading = true;
    this.acceptanceAccountService.getAcceptanceAccountById(this.acceptanceAccountId).subscribe(acceptanceAccount => {
        this.acceptanceAccount = acceptanceAccount;
        if(this.router.url.startsWith("/service/acceptanceaccounts/edit")) {
          this.isEditMode = true;
          this.supplierId = this.acceptanceAccount.supplierId;
          this.getSupplierName(this.acceptanceAccount.supplierId).subscribe(name => {
            this.supplierName = name;
            this.isLoading = false;
            this.initForm();
          })
        } else {
          this.isDetailsMode = true;
          this.isLoading = false;
        }
      });
    }

  }

  get acceptanceAccountControls() {
    return this.acceptanceAccountForm.controls;
  }


  initForm() : void {
    this.acceptanceAccountForm = this.formBuilder.group({
      acceptanceAccountId: new FormControl(this.isCreateMode ? '' : this.acceptanceAccount.acceptanceAccountId, Validators.required),
      merchantId: new FormControl(this.isCreateMode ? '' : this.acceptanceAccount.merchantId, Validators.required),
      posId: new FormControl(this.isCreateMode ? '' : this.acceptanceAccount.posId, Validators.required),
      supplierId: new FormControl(this.isCreateMode ? '' : this.supplierName +" ("+ this.acceptanceAccount.supplierId +")"),
      issuerType: new FormControl(this.isCreateMode ? '' : this.acceptanceAccount.issuerType),
      acceptanceAccountProvider: new FormControl(this.isCreateMode ? '' : this.acceptanceAccount.acceptanceAccountProvider, Validators.required),
      providerSpecParameter: new FormControl(this.isCreateMode ? '' : JSON.stringify(this.acceptanceAccount.providerSpecificParameters), Validators.compose([
        Validators.required,
        jsonValidator
      ])),
    });

    this.acceptanceAccountForm.get("posId").valueChanges.subscribe(() => {
      this.posService.getPosById(this.acceptanceAccountForm.get("posId").value).subscribe(pos => {
        this.supplierName = '';
        this.supplierId = null;
        if(pos.supplierId != null && pos.supplierId != undefined){
          this.supplierId = pos.supplierId;
        }
          this.getSupplierName(this.supplierId).subscribe(supp => {
            this.supplierName = supp;
            this.acceptanceAccountForm.get("supplierId").setValue(this.supplierName +' ('+this.supplierId+')');
          })
      })
    });

  }

  save() : void {
    const acceptanceAccount= Object.assign({}, this.acceptanceAccount);

    acceptanceAccount.id = this.acceptanceAccount.id;
    acceptanceAccount.acceptanceAccountId = this.acceptanceAccountForm.get('acceptanceAccountId').value;
    acceptanceAccount.merchantId = this.acceptanceAccountForm.get('merchantId').value;
    acceptanceAccount.posId = this.acceptanceAccountForm.get('posId').value;
    acceptanceAccount.issuerType = this.acceptanceAccountForm.get('issuerType').value;
    this.criteria = {
      merchantId: this.acceptanceAccountForm.get('merchantId').value,
      posId: this.acceptanceAccountForm.get('posId').value
    }

    this.checkDuplicateMerchantIdPosId().subscribe(accaccounts => {
      if(accaccounts.content.length != 0 && (acceptanceAccount.merchantId != this.acceptanceAccount.merchantId
        || acceptanceAccount.posId != this.acceptanceAccount.posId)){
        this.notifService.notifyErrorWithoutDetail('DUPLICATE_MERCHANT_ID_POS_ID');
      }
      else{
        if(this.supplierId != null){
          acceptanceAccount.supplierId = this.supplierId;
        }
      acceptanceAccount.acceptanceAccountProvider = this.acceptanceAccountForm.get('acceptanceAccountProvider').value;
      acceptanceAccount.providerSpecificParameters = JSON.parse(this.acceptanceAccountForm.get('providerSpecParameter').value);
      this.acceptanceAccountService.updateAcceptanceAccount(acceptanceAccount).subscribe(() => {
      this.router.navigate(['/service/acceptanceaccounts']);
      this.notifService.notifySuccess('ACCEPTANCEACCOUNT_UPDATED');
    });
  }});
  }

  onSubmitForm() {
    let acceptanceAccount = new AcceptanceAccount();

    acceptanceAccount.acceptanceAccountId = this.acceptanceAccountForm.get('acceptanceAccountId').value;
    acceptanceAccount.merchantId = this.acceptanceAccountForm.get('merchantId').value;
    acceptanceAccount.posId = this.acceptanceAccountForm.get('posId').value;
    acceptanceAccount.issuerType = this.acceptanceAccountForm.get('issuerType').value;
    this.criteria = {
      merchantId: this.acceptanceAccountForm.get('merchantId').value,
      posId: this.acceptanceAccountForm.get('posId').value
    }

    this.checkDuplicateMerchantIdPosId().subscribe(accaccounts => {
      if(accaccounts.content.length != 0){
        this.notifService.notifyErrorWithoutDetail('DUPLICATE_MERCHANT_ID_POS_ID');
      }
      else{
        if(this.supplierId != null){
          acceptanceAccount.supplierId = this.supplierId;
        }
        acceptanceAccount.acceptanceAccountProvider = this.acceptanceAccountForm.get('acceptanceAccountProvider').value;
        acceptanceAccount.providerSpecificParameters = JSON.parse(this.acceptanceAccountForm.get('providerSpecParameter').value);
          this.acceptanceAccountService.createAcceptanceAccount(acceptanceAccount).subscribe((acceptanceaccount) => {
          this.router.navigate(['/service/acceptanceaccounts']);
          this.notifService.notifySuccess('ACCEPTANCEACCOUNT_CREATED');
          });
      }
    });
  }

  getPos(){
    this.posService.findByCriteria({}, this.posPager, false).subscribe(posItems => {
      let posEnroll: PointOfService = new PointOfService();
      posEnroll.id = -1;
      posEnroll.name = "ENROLLEMENT";
      this.allPOS = posItems.content;
      this.posPager.page += 1;
      this.allPOS.push(posEnroll);
      this.posTotalPages = posItems.totalPages;
    })
  }

  fetchMorePos() {
    if (this.posPager.page < this.posTotalPages) {
      this.posService.findByCriteria({}, this.posPager, false).subscribe(posItems => {
        this.allPOS = [...this.allPOS, ...posItems.content];
          this.posPager.page += 1;
      })
    }
  }

  checkDuplicateMerchantIdPosId(): Observable<Items<AcceptanceAccount>>{
    return this.acceptanceAccountService.findByCriteria(this.criteria, {}, false).pipe(
      map(accaccounts => accaccounts)
    );
  }

  back() {
    this.router.navigate(["/service/acceptanceaccounts"]);
  }

  nameAndIdSearchFn = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    return this.translateService.instant(item.name).toLocaleLowerCase().indexOf(term) > -1 || item.id.toString().indexOf(term) > -1 ;
  }

  edit(): void {
    this.router.navigate(['/service/acceptanceaccounts/edit', this.acceptanceAccountId]);
  }

  private getPOSAndCache(id: number): Observable<PointOfService> {
    if (this.posObservables.has(id)) {
        return this.posObservables.get(id);
    } else {
        let obs = this.posService.getPosById(id).pipe(take(1));
        this.posObservables.set(id, obs);
        return obs;

    }
}
  public getPosName(id: number): Observable<string> {
    if (id) {
        if (this.posNameObservables.has(id)) {
            return this.posNameObservables.get(id);
        } else {
            let res = this.getPOSAndCache(id).pipe(map(s => s.name));
            this.posNameObservables.set(id, res);
            return res;
        }
    } else {
        return this.nameNotFoundObs;
    }
}

}
